module.exports = __webpack_public_path__ + "img/goal-three-br.f3da404b.png";